import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Game from "./../pages/Game";
import HomePage from "../pages/HomePage";


const Routes = () => {
    return (
        <Switch>
            <Redirect from="/" exact to="/home" />
            <Route exact  path="/home" component={HomePage} />
            <Route exact path="/game" component={Game} />
            
        </Switch>
    )
}

export default Routes;
